// PC

export const HOST = ['https://web-test.tradeup.com', 'https://web.tradeup.com'];
export const API = {
    host: ''
};
